export default {
  styleOverrides: {
    root: {
      position: 'fixed',
      bottom: '70px',
      right: '20px',
      zIndex: 1050,
      minHeight: '56px',
      minWidth: '56px',
    },
  },
};
